import React from "react";
import { Typography } from "antd";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { ReactComponent as NoPatientsFoundIcon } from "../../assets/svg/NoPatientsFoundIcon.svg";
import { ReactComponent as NoEnrollmentsFoundIcon } from "../../assets/svg/no-enrollments-found-Icon.svg";

import { fontWeights, sizes } from "../../constant/styles";
import { BLACK, EE_400, EXPRESS_GREEN_ENROLL, GRAY_500 } from "../../constant/colors";

const { Text } = Typography;

const EEIconContainer = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: ${EXPRESS_GREEN_ENROLL};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
`;

const LightningIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 2L4.09344 12.6879C3.74463 13.1064 3.57023 13.3157 3.56756 13.4925C3.56524 13.6461 3.63372 13.7923 3.75324 13.8889C3.89073 14 4.16316 14 4.70802 14H12L11 22L19.9066 11.3121C20.2554 10.8936 20.4298 10.6843 20.4324 10.5075C20.4348 10.3539 20.3663 10.2077 20.2468 10.1111C20.1093 10 19.8368 10 19.292 10H12L13 2Z"
      fill="none"
      stroke={EE_400}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const emptyContentMap = (t) => {
  return {
    patients: {
      icon: <NoPatientsFoundIcon />,
      messageKey: t("no_patients_found")
    },
    enrollments: {
      icon: <NoEnrollmentsFoundIcon />,
      messageKey: t("no_enrollments_found")
    },
    relevantPatients: {
      icon: <NoPatientsFoundIcon />,
      messageKey: t("no_relevant_patients_found")
    },
    expressEnrollEligible: {
      icon: (
        <EEIconContainer>
          <LightningIcon />
        </EEIconContainer>
      ),
      title: t("ee_empty_state_title"),
      subtitle: t("ee_empty_state_subtitle")
    }
  };
};

const EmptyTableMessage = ({ type = "patients" }) => {
  const { t } = useTranslation();
  const content = emptyContentMap(t)[type];

  if (type === "expressEnrollEligible") {
    return (
      <div
        id="empty-table-message"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "48px 24px",
          margin: "1em"
        }}
      >
        {content.icon}
        <Text
          style={{
            fontWeight: fontWeights.semibold,
            color: BLACK,
            fontSize: sizes.medium_large,
            textAlign: "center",
            marginBottom: "8px"
          }}
        >
          {content.title}
        </Text>
        <div style={{ width: "350px", textAlign: "center", whiteSpace: "normal" }}>
          <Text
            style={{
              fontWeight: fontWeights.regular,
              color: GRAY_500,
              fontSize: sizes.medium,
              lineHeight: "20px"
            }}
          >
            {content.subtitle}
          </Text>
        </div>
      </div>
    );
  }

  const { icon, messageKey } = content;

  return (
    <div
      id="empty-table-message"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: type === "enrollments" ? 8 : 0,
        margin: "1em"
      }}
    >
      {icon}
      <Text
        style={{
          fontWeight: fontWeights.semibold,
          color: BLACK,
          fontSize: sizes.medium_large,
          opacity: "0.5",
          whiteSpace: "pre-line",
          textAlign: "center"
        }}
      >
        {messageKey}
      </Text>
    </div>
  );
};

export default EmptyTableMessage;
